module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/small/emblem.6239111e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/Reward/images/rewards/small/emblem.png
// module id = 3469
// module chunks = 11